// ═══════════════════════════════════════════════════════════════════
//  modules/erp/MinecraftInventory.js
//  MinecraftInventory
// ═══════════════════════════════════════════════════════════════════

import { ItemIcon } from "./ItemIcon";
import { MC_LABEL, MC_PANEL } from "./styles";

export function MinecraftInventory({ items, canAct, onSlotClick }) {
  // Slots : armure 100-103, off-hand -106, inventaire 9-35, hotbar 0-8
  const getItem = (slot) => items.find((i) => i.slot === slot) || null;

  const armorSlots = [103, 102, 101, 100];
  const armorGhost = ["🪖", "🛡️", "👖", "👢"];

  const cell = (slot, ghost) => {
    const it = getItem(slot);
    return <ItemIcon key={slot} item={it} ghost={ghost}
      clickable={canAct && !!it} onClick={() => onSlotClick && onSlotClick("MAIN", slot, it)} />;
  };

  return (
    <div style={MC_PANEL}>
      <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
        {/* Colonne armure + 2e main */}
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <div style={MC_LABEL}>ARMURE</div>
          {armorSlots.map((slot, i) => cell(slot, armorGhost[i]))}
          <div style={{ marginTop: 8 }}>
            <div style={MC_LABEL}>2e MAIN</div>
            {cell(-106, "🛡️")}
          </div>
        </div>

        {/* Inventaire principal 3×9 */}
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <div style={MC_LABEL}>INVENTAIRE</div>
          {[0, 1, 2].map((row) => (
            <div key={row} style={{ display: "flex", gap: 6 }}>
              {Array.from({ length: 9 }, (_, col) => cell(9 + row * 9 + col))}
            </div>
          ))}
        </div>
      </div>

      {/* Hotbar 1×9 */}
      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 6 }}>
        <div style={MC_LABEL}>RACCOURCIS</div>
        <div style={{ display: "flex", gap: 6 }}>
          {Array.from({ length: 9 }, (_, i) => cell(i))}
        </div>
      </div>
    </div>
  );
}
